import qs from "qs";
import axios, { AxiosPromise } from "axios";
import { RailsFormErrors, FetchParams, NewsLetter } from "../types";
import { axiosHeader } from "../constants";

type Service = {
  fetchAll: (params: FetchParams) => AxiosPromise<NewsLetter[]>;
  add: (videoId: number) => AxiosPromise<{
    success: boolean;
    instance: number;
    errors: RailsFormErrors;
  }>;
  send: (subject: string) => AxiosPromise<{
    success: boolean;
    instance: string;
    errors: RailsFormErrors;
  }>;
  delete: (videoId: number) => AxiosPromise;
};

export const NewsLetterService: Service = {
  fetchAll: (params) =>
    axios.get("/api/ikm/v1/video_newsletter_lists", {
      params: {
        page: params.pageNumber,
        per_page: params.pageSize,
      },
    }),
  add: (videoId: number) =>
    axios({
      url: "/api/ikm/v1/video_newsletter_lists",
      method: "post",
      headers: axiosHeader,
      data: qs.stringify({ video_id: videoId }),
    }),
  send: (subject: string) =>
    axios({
      url: "/api/ikm/v1/newsletters",
      method: "post",
      headers: axiosHeader,
      data: qs.stringify({ "newsletter[subject]": subject }),
    }),
  delete: (videoId: number) =>
    axios({
      url: "/api/ikm/v1/video_newsletter_lists/" + videoId,
      method: "delete",
    }),
};

export default NewsLetterService;
